// mui
import { Box, Button, Container, Divider, Stack } from '@mui/material';

// templates
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

// organisms
import { Editor } from '@/components/organisms/Editor/Editor';
import { FieldDef } from '@/components/organisms/EditorFields/fieldHelper';

export interface NewAccountPageProps {
  fields: Record<string, FieldDef>;
  value: any;
  onChange: (value: any, key: string) => void;
  onBack: () => void;
  onSave: () => void;
}

/**
 * NewAccountPage provides the page design for creating a new account.
 */
export const NewAccountPage = ({
  fields,
  value,
  onChange,
  onBack,
  onSave,
}: NewAccountPageProps) => {
  return (
    <ModalPageTemplate
      onBack={onBack}
      footerSlot={
        <Box
          sx={{
            bgcolor: 'background.default',
          }}
        >
          <Divider />
          <Container maxWidth='sm'>
            <Stack
              direction='row'
              spacing={2}
              sx={{
                py: 2,
              }}
            >
              <Button variant='outlined' fullWidth onClick={onBack}>
                Cancel
              </Button>
              <Button variant='contained' fullWidth onClick={onSave}>
                Save
              </Button>
            </Stack>
          </Container>
        </Box>
      }
    >
      <PageTemplate
        maxWidth='sm'
        headerSlot={
          <PageHeader title='New Account' description='Create a new account' />
        }
        contentSlot={
          <Editor
            isActionsDisabled
            isFloatingActions={false}
            isForm={false}
            value={value}
            onChange={onChange}
            fields={fields}
          />
        }
      />
    </ModalPageTemplate>
  );
};

NewAccountPage.displayName = 'NewAccountPage';
export default NewAccountPage;
